<template>
  <div>
    <v-data-table id="tblLiquidacion" :headers="fields" :items="data" hide-actions>
      <template slot="items" slot-scope="props">
        <td class="text-lg-left">{{ props.item.nombre }}</td>
        <td class="text-xs-right">
          <Numeric
            :id="'tipoLiquidacion' + props.item.id"
            :value="props.item.tipo"
            :readonly="true"
            :precision="precisionTipo"
            v-if="props.item.tipo"
          ></Numeric>
        </td>
        <td class="text-xs-right">
          <Numeric
            :id="'importeRegulado' + props.item.id"
            v-model="props.item.cuotaTributaria"
            :min="minValue"
            :max="maxValue"
            v-if="props.item.id == 'RE' || props.item.id == 'RG'"
          ></Numeric>
          <Numeric
            :id="'cuotaTributaria' + props.item.id"
            :value="props.item.cuotaTributaria"
            :readonly="true"
            :precision="precisionCuota"
            v-if="props.item.cuotaTributaria && props.item.id != 'RE' && props.item.id != 'RG'"
          ></Numeric>
        </td>
      </template>
      <template slot="footer">
        <td></td>
        <td class="text-xs-right total">{{ $t('message.tasas.liquidacion.total') }}</td>
        <td class="text-xs-right total">
          <strong>
            <Numeric
              id="totalCuotaLiquidacion"
              :value="totalCuota"
              :readonly="true"
              :precision="precisionCuota"
              currency="€"
            ></Numeric>
          </strong>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { Numeric } from '@/components';
export default {
  name: 'liquidacion-tasa',
  props: {
    label: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      fields: [
        { value: 'nombre', text: '', align: 'left', sortable: false },
        {
          value: 'tipo',
          text: this.$t('message.tasas.liquidacion.tipo'),
          align: 'right',
          sortable: false
        },
        {
          value: 'cuotaTributaria',
          text: this.$t('message.tasas.liquidacion.cuotaTributaria'),
          align: 'right',
          sortable: false
        }
      ],
      precisionTipo: 3,
      precisionCuota: 2,
      minValue: -999999999,
      maxValue: 0
    };
  },
  components: {
    Numeric
  },
  computed: {
    totalCuota() {
      let totalCuota = this.data.reduce((total, item) => {
        if (item.cuotaTributaria == '') {
          return total;
        }
        return total + item.cuotaTributaria;
      }, 0);
      return totalCuota;
    }
  }
};
</script>
